import React from "react"
import { StringProperty } from "../../@types/EpiFoundationSpa/Property"
import { BlockCommonLayout } from "../../utils/layout"
import {
	Category,
	PropertyCategory,
	QBankImage,
} from "../../@types/CapioWeb/core"
import { NewsArchiveFilter, NewsArchiveList } from "./components"
import ContentLink from "../../@types/EpiFoundationSpa/Models/ContentLink"
import { NewsArchiveFilterContextProvider } from "./context/NewsArchiveContext"

export interface NewsArchiveItem {
	heading: StringProperty
	preamble: StringProperty
	imageDesktopBlock: QBankImage
	contentLink: ContentLink
	publishingDate: string
	organisations: PropertyCategory[]
	newsSubjects: PropertyCategory[]
	organisationIds: number[]
	newsSubjectsIds: number[]
}
export interface NewsProps {
	items: NewsArchiveItem[]
	organisationsFilterValues: Category[]
	subjectsFilterValues: Category[]
	totalItems: number
}
export interface CapioNexusNewsArchiveBlockProps {
	news: NewsProps
}

const CapioNexusNewsArchiveBlock: React.FC<CapioNexusNewsArchiveBlockProps> = (
	props
) => {
	return (
		<>
			<NewsArchiveFilterContextProvider>
				<NewsArchiveFilter {...props.news}></NewsArchiveFilter>
				<BlockCommonLayout>
					<NewsArchiveList {...props.news}></NewsArchiveList>
				</BlockCommonLayout>
			</NewsArchiveFilterContextProvider>
		</>
	)
}

export { CapioNexusNewsArchiveBlock }
